import OfCourseLogo from "/src/assets/images/logos/ofcourse-logo.svg";
import { Mail } from "lucide-react";

const StarterContainer = (props: { children: React.ReactNode }) => {
  return (
    <div className="w-full h-full bg-white flex flex-col lg:flex-row items-center">
      <div className="w-full lg:w-[1200px] h-full flex flex-col justify-between items-center">
        <div className="w-full h-[96px] px-4 lg:px-8 flex justify-start items-start">
          <img
            src={OfCourseLogo}
            alt="Of Course Logo"
            className="w-[153px] h-[42.19px]"
          />
        </div>
        <div className="w-full lg:w-[528px] space-y-4 px-4 lg:px-0">{props.children}</div>
        <div className="w-full h-24 px-4 lg:px-8 flex justify-between items-end">
          <div className="text-[#475466] text-sm font-normal font-['Inter'] leading-tight">
            © Of Course 2024
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4" />
            <div className="text-[#475466] text-sm font-normal font-['Inter'] leading-tight">
              <Mail className="inline h-4" /> support@ofcourse.com
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-full relative bg-[#f2f3f6] rounded-[15px] overflow-hidden mt-4 lg:mt-0">
        <div className="absolute inset-0 flex justify-center items-center">
          <div className="w-full h-full bg-banner-login bg-cover bg-center rounded-[15px]"></div>
        </div>
      </div>
    </div>
  );
};

export default StarterContainer;
